<template>
  <div class="mb-3">
    <div class="form-group" :class="{'has-error': hasError('aro')}">
      <div class="col-sm-6">
        <label class="required">IS DEALER ARO? (IF ARO DEALER PLEASE MOVE ONTO THE DEALER INFORMATION SECTION)</label>
        <div class="checkbox">
          <label>
            <input name="aro" type="checkbox" :value="'1'" id="aro" v-model="form.aro" true-value="1" false-value="0"> ARO
          </label>
          <span v-if="hasError('aro')" class="help-block error-help-block">{{ getError('aro')}}</span>
        </div>
      </div>
    </div>
    <div class="form-group" :class="{'has-error': hasError('dia') || hasError('isa')}">
      <div class="col-sm-6">
        <label for="programs" class="required">Programs <span class="required">*</span></label>
        <div class="checkbox">
          <label>
            <input name="dia" type="checkbox" :value="'1'" id="dia" v-model="form.dia" true-value="1" false-value="0"> DIA
            <span v-if="hasError('dia')" class="help-block error-help-block">{{ getError('dia')}}</span>
          </label>
          <br />
          <label>
            <input name="isa" type="checkbox" :value="'1'" id="isa" v-model="form.isa" true-value="1" false-value="0"> ISA
            <span v-if="hasError('isa')" class="help-block error-help-block">{{ getError('isa')}}</span>
          </label>
        </div>
      </div>
    </div>
    <div v-if="form.isa === '1'" id="isa-contact">
      <h2>ISA/Text to Apply Champion</h2>
      <input type="hidden" name="isa" value="1">
      <div class="form-group" :class="{'has-error': hasError('dealer_contact.isa_name')}">
        <label for="isa_name" class="required col-sm-4 control-label">Full name <span class="required">*</span></label>
        <div class="col-sm-6">
          <input type="text" name="dealer_contact[isa_name]" id="isa_name" class="form-control" value="" v-model="form.dealer_contact.isa_name">
          <span v-if="hasError('dealer_contact.isa_name')" class="help-block error-help-block">{{ getError('dealer_contact.isa_name')}}</span>
        </div>
      </div>
      <div class="form-group" :class="{'has-error': hasError('dealer_contact.isa_email')}">
        <label for="isa_email" class="required col-sm-4 control-label">Email <span class="required">*</span></label>
        <div class="col-sm-6">
          <input type="text" name="dealer_contact[isa_email]" id="isa_email" class="form-control" value="" v-model="form.dealer_contact.isa_email">
          <span v-if="hasError('dealer_contact.isa_email')" class="help-block error-help-block">{{ getError('dealer_contact.isa_email')}}</span>
        </div>
      </div>
      <div class="divider"></div>
    </div>
    <div v-if="form.dia === '1'" id="dia-contact">
      <h2>DIA Champion</h2>
      <div class="form-group" :class="{'has-error': hasError('dealer_contact.dia_name')}">
        <label for="dia_name" class="required col-sm-4 control-label">Full name <span class="required">*</span></label>
        <div class="col-sm-6">
          <input type="text" name="dealer_contact[dia_name]" id="dia_name" class="form-control" value="" v-model="form.dealer_contact.dia_name">
          <span v-if="hasError('dealer_contact.dia_name')" class="help-block error-help-block">{{ getError('dealer_contact.dia_name')}}</span>
        </div>
      </div>
      <div class="form-group" :class="{'has-error': hasError('dealer_contact.dia_email')}">
        <label for="dia_email" class="required col-sm-4 control-label">Email <span class="required">*</span></label>
        <div class="col-sm-6">
          <input type="text" name="dealer_contact[dia_email]" id="dia_email" class="form-control" value="" v-model="form.dealer_contact.dia_email">
          <span v-if="hasError('dealer_contact.dia_email')" class="help-block error-help-block">{{ getError('dealer_contact.dia_email')}}</span>
        </div>
      </div>
      <div class="divider"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    request: {
      type: [Object, Array],
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {...{
          isa: '0',
          dia: '0',
          aro: '0',
          dealer_contact: {
            isa_email: '',
            isa_name: '',
            dia_email: '',
            dia_name: '',
          }
        },...this.request
      }
    }
  },
  methods: {
    hasError(key) {
      return this.errors && this.errors.hasOwnProperty(key);
    },
    getError(key) {
      if (this.errors[key][0]) {
        return this.errors[key][0];
      }
    }
  },
  watch: {
    'form.isa': function (newVal, oldVal){
      if (newVal === '0') {
        this.form.dealer_contact.isa_email = '';
        this.form.dealer_contact.isa_name = '';

        if (this.errors.hasOwnProperty('dealer_contact.isa_email')) {
          delete this.errors['dealer_contact.isa_email'];
        }

        if (this.errors.hasOwnProperty('dealer_contact.isa_name')) {
          delete this.errors['dealer_contact.isa_name'];
        }

        if (this.form.dia !== '0') {
            this.form.dia = '0'
        }
      } else {
          if (this.form.dia !== '1') {
              this.form.dia = '1'
          }
      }
    },
    'form.dia': function (newVal, oldVal){
      if (newVal === '0') {
        this.form.dealer_contact.dia_email = '';
        this.form.dealer_contact.dia_name = '';

        if (this.errors.hasOwnProperty('dealer_contact.dia_email')) {
          delete this.errors['dealer_contact.dia_email'];
        }

        if (this.errors.hasOwnProperty('dealer_contact.dia_name')) {
          delete this.errors['dealer_contact.dia_name'];
        }

        if (this.form.isa !== '0') {
            this.form.isa = '0'
        }
      } else {
          if (this.form.isa !== '1') {
              this.form.isa = '1'
          }
      }
    },
  }
}
</script>